import {
  install as installAxeptioSdk,
  isInstalled as isAxeptioSdkInstalled,
  type i18nConfig,
} from '@b2ag/plugin-axeptio'
import { useAnalyticService } from '@b2ag/plugin-aladin-gtm'
import { getConfig } from '@b2ag/micro-front-tools'
import { featuresForCurrentBrand } from '@b2ag/app-brands/dist/features'
import { getLocaleForI18n } from '@b2ag/utils/src/i18n-routing'

/**
 * deletes a cookie
 * credits https://stackoverflow.com/a/30387077/521257
 */
function unsetCookie(name, path, domain) {
  document.cookie =
    encodeURIComponent(name) +
    '=; expires=Thu, 01 Jan 1970 00:00:00 GMT' +
    (domain ? '; domain=' + domain : '') +
    (path ? '; path=' + path : '')
}

/**
 * Loads the Axeptio SDK script if not already done
 * @param store
 */
export function initAxeptioIfNeeded(consentToken?: string) {
  if (import.meta.server) return
  if (window.location.origin.includes('localhost')) return

  if (getConfig('AXEPTIO_CLIENT_ID')) {
    if (!isAxeptioSdkInstalled()) {
      if (consentToken) {
        unsetCookie('invivo_axeptio_cookies', '/', getConfig('AXEPTIO_DOMAIN'))
      }

      const axeptioConfig = featuresForCurrentBrand.axeptio
      let base: string | i18nConfig = getConfig('AXEPTIO_BASE') // cookiesVersion

      if (axeptioConfig?.i18n) {
        const cases = axeptioConfig.i18n.cases

        if (getConfig('ENVIRONMENT_NAME') === 'QUA' || getConfig('ENVIRONMENT_NAME') === 'TEST') {
          Object.keys(cases).forEach((key) => {
            cases[key] = cases[key] + '_QUA'
          })
        }
        const currentLocale = getLocaleForI18n(window.location.pathname) || 'default'
        base = cases[currentLocale] as string
      }

      installAxeptioSdk(null, {
        token: consentToken,
        clientId: getConfig('AXEPTIO_CLIENT_ID'),
        base,
        domain: getConfig('AXEPTIO_DOMAIN'),
        flushStoredEvents: () => useAnalyticService()?.flushStoredEvents(),
      })
    }
  }
}
